module.exports = __webpack_public_path__ + "img/codeclinic_logo.804d987c.png";